const supplier = {
  //
}

export default supplier
